export default __webpack_public_path__ + "static/media/miguel-lopes-8.fbc79c57.jpg";